module.exports = __webpack_public_path__ + "static/img/38313311071575808.465738a.png";


//////////////////
// WEBPACK FOOTER
// ./src/project/voteProject/image/38313311071575808.png
// module id = e0U/
// module chunks = 5